import { SELECT_TRANSFER_CHANGE } from '../actions/transferencia-entrega.actions'

const initialState = {
  selectedTransferencia: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SELECT_TRANSFER_CHANGE:
      return {
        ...state,
        selectedTransferencia: action.selectedTransferencia,
      }
    default:
      return state
  }
}
